// extracted by mini-css-extract-plugin
export default {"footer":"H_bH","row":"H_c3","menuColumn":"H_c4","trademarks":"H_c5"};